import { Api } from "../config/request";

export default {
  getTelecallerLeads(params) {
    return Api.get(`/telecaller/leads${params}`);
  },
  getReasons() {
    return Api.get("/telecaller/lead-engagement/reasons");
  },
  updateLeadEngagement(payload) {
    return Api.post("/telecaller/lead-engagement/update", payload);
  },
  getFilterTelecallerLeads(payload) {
    return Api.post(`/telecaller/lead-engagement/filter`, payload);
  },
};
